export const Papers = [
    {
        Title: "NARMADA: Need and Available Resource Managing Assistant for Disasters and Adversities",
        URL: "https://www.aclweb.org/anthology/2020.socialnlp-1.3/",
        Venue: {
            Full: "ACL 2020 workshop on Natural Language Processing for Social Media (SocialNLP)",
            Short: "ACL '20",
        },
        When: "May 2020",
        Authors: "*Kaustubh Hiware, Ritam Dutt, Sayan Sinha, Sohan Patro, Kripabandhu Ghosh, Saptarshi Ghosh",
    },
    {
        Title: "Emotion detection from touch interactions during text entry on smartphones",
        URL: "https://www.sciencedirect.com/science/article/abs/pii/S1071581918304889",
        Venue: {
            Full: "International Journal of Human-Computer Studies, 2019",
            Short: "IJHCI '19"
        },
        When: "Oct 2019",
        Authors: "Surjya Ghosh, *Kaustubh Hiware, Niloy Ganguly, Bivas Mitra, Pradipta De",
    },
    {
        Title: "A comparative study of summarization algorithms applied to legal case judgments",
        URL: "https://www.sciencedirect.com/science/article/abs/pii/S1071581918304889",
        Venue: {
            Full: "European Conference on Information Retrieval, 2019",
            Short:"ECIR '19"
        },
        When: "Apr 2019",
        Authors: "Paheli Bhattacharya, *Kaustubh Hiware, Subham Rajgaria, Nilay Pochhi, Kripabandhu Ghosh, Saptarshi Ghosh",
    },
    {
        Title: "Does emotion influence the use of auto-suggest during smartphone typing?",
        URL: "https://www.researchgate.net/profile/Surjya_Ghosh/publication/331214440_Does_emotion_influence_the_use_of_auto-suggest_during_smartphone_typing/links/5ca43ff792851c8e64aed384/Does-emotion-influence-the-use-of-auto-suggest-during-smartphone-typing.pdf",
        Venue: {
            Full: "International Conference on Intelligent User Interfaces, ACM, IUI 2019",
            Short: "IUI '19",
        },
        When: "Mar 2019",
        Authors: "Surjya Ghosh, *Kaustubh Hiware, Bivas Mitra, Niloy Ganguly, Pradipta De",
    },
    {
        Title: "Savitr: A system for real-time location extraction from microblogs during emergencies",
        URL: "https://dl.acm.org/doi/10.1145/3184558.3191623",
        Venue: {
            Full: "WWW 2018 workshop on Exploitation of Social Media for Emergency Relief and Preparedness (SMERP)",
            Short: "WWW '18"
        },
        When: "Apr 2018",
        Authors: "Ritam Dutt, *Kaustubh Hiware, Avijit Ghosh, Rameshwar Bhaskaran",
    },
    {
        Title: "A Graph Based Semi-Supervised Approach for Analysis of Derivational Nouns in Sanskrit",
        URL: "https://www.aclweb.org/anthology/W17-2409/",
        Venue: {
            Full: "ACL 2017 workshop on Graph-based Methods for Natural Language Processing (TextGraphs-11)",
            Short: "ACL '17",
        },
        When: "Aug 2017",
        Authors: "Amrith Krishna, Pavankumar Satuluri, Harshavardhan Ponnada, Muneeb Ahmed, Gulab Arora, *Kaustubh Hiware, Pawan Goyal",
    },
];

export default Papers;